import * as types from '../../constants/action_types'

export const initialState = {
  supplierNotes: {},

  saveNote: {
    isLoading: false,
    completed: false
  },

  deleteNote: {
    isLoading: false,
    completed: false
  },

  note: {
    title: '',
    body: ''
  }
}

function supplierTrackerNotesReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_SUPPLIER_NOTES:
      return {
        ...state,
        supplierNotes: {
          ...state.supplierNotes,
          ...action.payload
        }
      }
    case types.PENDING_SUPPLIER_NOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: true,
          completed: false
        }
      }
    case types.COMPLETED_SUPPLIER_NOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: false,
          completed: true
        }
      }
    case types.RESET_SUPPLIER_NOTES_ACTION:
      return {
        ...state,
        [action.payload]: {
          isLoading: false,
          completed: false
        }
      }
    case types.SET_SUPPLIER_NOTE:
      return {
        ...state,
        note: {
          ...initialState.note,
          ...action.payload
        }
      }
    default:
      return state
  }
}

export default supplierTrackerNotesReducer
